import React, { useEffect } from "react";

const Fallback = () => {
  useEffect(() => {
    const handleReload = () => window.location.reload();
    window.addEventListener("popstate", handleReload);

    return () => {
      window.removeEventListener("popstate", handleReload);
    };
  }, []);

  return (
    <div className="error-wrapper">
      <div className="c1">
        <p className="went_wrong_text">Oops! Something went wrong.</p>
        <div className="d-flex flex-column flex-nowrap align-items-center m-0">
          <p className="text">
            We&apos;re experiencing technical issues. Please try refreshing the page.
          </p>
          <button
            className="refresh_btn"
            onClick={() => window.location.reload()}
          >
            Reload
          </button>
        </div>
      </div>
    </div>
  );
};

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // console.log("error :>> ", error);
    const payload = {
      error_message: error.message,
      description: `File Name:\n${error?.fileName}\n\nComponent Stack:\n${info?.componentStack}\n\nStack:\n${error.stack}`,
    };
    // console.error("ErrorBoundary payload:", payload);
  }

  render() {
    if (this.state.hasError) {
      return <Fallback />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
